import { render } from "./SendMail.vue?vue&type=template&id=49c99508&scoped=true"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "./SendMail.vue?vue&type=style&index=0&id=49c99508&scoped=true&lang=css"

import exportComponent from "/var/www/html/mohsen-ampd-agency/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c99508"]])

export default __exports__